import { useTranslation } from "react-i18next";
import { useState } from "react";
import Tabs from "./tabs";
import { FaChevronLeft } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import ProfileImage from "./profileImage";
import ProfileTab from "./tabs/profileTab";
import JobInformationTab from "./tabs/jobInformationTab";
import SalaryAndContract from "./tabs/salaryAndContractTab";
import AttendanceAndVacation from "./tabs/attendanceAndVacation";
import PrevRequestsTab from "./tabs/prevRequestsTab";
import DocumentsTab from "./tabs/documents";

const OneEmployee = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState("profile");

  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <main>
      <div className="flex items-center gap-4 mb-3">
        <h1
          onClick={() => navigate("/employees")}
          className="text-lg font-bold capitalize cursor-pointer md:text-2xl text-primary"
        >
          {t("employees-1")}
        </h1>
        <FaChevronLeft className="ltr:rotate-180" />
        <p className="font-bold capitalize">{id}</p>
      </div>
      <Tabs t={t} setTab={setTab} tab={tab} />
      <article className=" grid gap-4 md:grid-cols-[auto_1fr] mt-8">
        <ProfileImage id={id} />
        {tab === "profile" && <ProfileTab t={t} id={id} />}
        {tab === "jopInfo" && <JobInformationTab t={t} id={id} />}
        {tab === "contract" && <SalaryAndContract t={t} />}
        {tab === "attendance" && <AttendanceAndVacation t={t} />}
        {tab === "requests" && <PrevRequestsTab t={t} />}
        {tab === "docs" && <DocumentsTab t={t} />}
      </article>
    </main>
  );
};

export default OneEmployee;
